export { default as LoyaltyGreetingWidget } from './loyalty-greeting-widget';
